<template>
  <div class="add-new-client">

    <md-dialog :md-active.sync="deleteDialog">
      <md-dialog-title>
        <span>Delete brand</span>
        <button class="btn btn--close" @click="deleteDialog = false; showDialog = true"></button>
      </md-dialog-title>
      <div class="margin-auto">
        <span>Are you sure you want to delete the next:</span>
        <div class="textTitle margin-medium--top">
          <span class="margin-auto textTitlesilver">{{ client.name }}</span>
        </div>
      </div>
      <md-dialog-actions>
        <div class="md-layout">
          <div class="md-layout-item row">
            <md-button class="md-primary modal-cancel-btn" @click="cancel; showDialog = true; deleteDialog = false">
              Cancel
            </md-button>
          </div>
          <div class="md-layout-item text-right">
            <md-button class="md-primary modal-delete-btn" @click="deleteClient">Delete</md-button>
          </div>
        </div>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="showDialog">
      <validation-observer v-slot="{ handleSubmit }" tag="div">
        <form @submit.prevent="handleSubmit(saveBrand)" class="form">
          <md-dialog-title>
            <span>Edit {{ client.name }} client</span>
            <button class="btn btn--close" @click="cancel"></button>
          </md-dialog-title>
          <div class="form__content">
            <ValidationProvider :rules="{required :true, min:3}" v-slot="{ errors }" tag="div">
              <md-field>
                <label>Client name</label>
                <md-input v-model="clientToEdit.name"/>
              </md-field>
              <div class="form__error">{{ errors[0] }}</div>
            </ValidationProvider>
            <ValidationProvider rules="required" v-slot="{ errors }" tag="div">
              <md-field>
                <label>Client logo</label>
                <div class="md-file">
                  <input readonly="readonly" class="md-input" v-model="fileNamesToUpload"/>
                  <input type="file" accept="image/*" @change="filesSelected"/>
                </div>
              </md-field>
              <div class="form__error">{{ errors[0] }}</div>
            </ValidationProvider>
            <!-- <img v-if="client.logo" :srcset="client.logo.srcset" style="width: 150px;">                                     -->
            <ValidationProvider :rules="{required :true, min:3}" v-slot="{ errors }" tag="div">
              <md-field>
                <label>Client information</label>
                <md-textarea v-model="clientToEdit.description"></md-textarea>
              </md-field>
              <div class="form__error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <md-dialog-actions>
            <div class="md-layout">
              <div class="md-layout-item row">
                <md-button class="md-primary modal-cancel-btn" @click="cancel">Cancel</md-button>
                <a class="hrefButton--black margin-medium--left" @click="deleteDialog = true; showDialog = false">Delete
                  Client</a>
              </div>
              <div class="md-layout-item text-right">
                <md-button class="md-primary modal-save-btn" type="submit">Save Client</md-button>
              </div>
            </div>
          </md-dialog-actions>
        </form>
      </validation-observer>
    </md-dialog>

    <div class='buttonContainer'>
      <button class="btn btn-edit" @click="showDialog = true; clientToEdit = {...client}">
        <img alt="Edit Button" class="editButton" src="@/assets/img/icons/edit.svg"/>
        Edit client
      </button>
    </div>
  </div>
</template>


<script>
import apiHandlerMI from "@/mixins/apiHandlerMI.js";
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {min, required} from 'vee-validate/dist/rules';
import {setInteractionMode} from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "This field is required."
});
extend('min', {
  ...min,
  message: "This field should contain at least 3 letters"
});

export default {
  mixins: [apiHandlerMI],
  props: ['client'],
  data() {
    return {
      showDialog: false,
      active: false,
      error: {},
      deleteDialog: false,
      type: 'square',
      needUpload: false,
      filesToUpload: null,
      fileNamesToUpload: undefined,
      clientToEdit: undefined
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  watch: {
    showDialog() {
      let _this = this

      if (_this.client.logo) {
        _this.fileNamesToUpload = _this.client.logo.file_name_original
      }
    }


  },
  methods: {
    deleteClient() {
      const _this = this;
      this.delete(`client/${this.client.id}`, {}, () => {
        _this.showDialog = false;
        _this.deleteDialog = false;
        _this.$router.push({name: 'Dashboard'});
      }, () => {
        console.log('Sikertelen Torles');
      });
    },
    filesSelected(event) {
      this.needUpload = true;
      this.filesToUpload = event.target.files;
      this.fileNamesToUpload = this.filesToUpload[0].name
    },
    upload_selected: function (num = 0) {
      if (!this.needUpload)
        return false;
      const _this = this;
      if (!(this.filesToUpload || []).length) {

        this.error.logo = "Image required!";
        this.$forceUpdate();
        return;
      }
      if (!this.type) {
        this.error.logo = "Type required!";
        this.$forceUpdate();
        return;
      }
      this.error.logo = undefined;
      if (this.filesToUpload.length <= num) {
        this.fileNamesToUpload = undefined;
        //this.uploadSuccess = `You have successfully uploaded ${num} files`;
        setTimeout(() => {
          _this.uploadSuccess = undefined;
        }, 3000);
        return;
      }

      let file = this.filesToUpload[num];

      const formData = new FormData();
      formData.append("files[0]", file);
      formData.append('payment_cluster_id',this.client.payment_cluster_id)
      formData.append("folder", 'client');
      formData.append("upload_type", this.type);

      var url = "image";
      if (this.filesToUpload[num].type == "application/pdf") url = "document";
      //console.log("start_upload");
      this.post(
          "filemanager/upload/" + url,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          },
          function (resp) {
            _this.needUpload = false;
            _this.clientToEdit.logo = resp.data.images[0];
            _this.saveBrandData();
            //_this.upload_selected(num + 1);
          }
      );
    },
    saveBrand() {
      if (this.needUpload)
        this.upload_selected();
      else {
        this.saveBrandData()
      }

    },
    saveBrandData() {
      var _this = this;
      const saveClient = this.clientToEdit;
      saveClient.client_id = this.client.id;
      if (saveClient.logo.id)
        saveClient.logo = saveClient.logo.id;
      this.put('client/' + saveClient.id, saveClient, {}, function () {
        //console.log(resp.data);

        if (_this.$parent.refreshClient)
          _this.$parent.refreshClient();
        _this.showDialog = false
      }, function (resp) {
        //console.log(resp);
        _this.error = resp.data.error;
        this.$forceUpdate();
      })
    },
    cancel() {
      this.showDialog = false

    }
  }
}

</script>